var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 2,
  y: 35.3,
  width: 41,
  height: 4.2,
  rx: 2.1,
  fill: "#d9e7f0"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 6.5,
  r: 0.9,
  fill: "#b9d2e2"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 33,
  cy: 7,
  r: 0.9,
  fill: "#b9d2e2"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 41.5,
  cy: 13.5,
  r: 0.8,
  fill: "#b9d2e2"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 4.5,
  cy: 14.5,
  r: 0.8,
  fill: "#b9d2e2"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m7.2 35.6c0-2.4 1.5-4.1 3.3-4.1 1 0 1.8 0.5 2.4 1.3 0.6 0.7 1.4 1.2 2.1 1.5v1.3z",
  fill: "#d9e7f0"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-10 7.8 20)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 5.4,
  y: 5.2,
  width: 5,
  height: 1.9,
  rx: 0.95,
  fill: "#9aa7b0"
}), /*#__PURE__*/React.createElement("rect", {
  x: 7,
  y: 6.5,
  width: 1.7,
  height: 19.5,
  fill: "#9aa7b0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m4 25.5h7.8c0.5 0 0.9 0.45 0.85 0.95l-0.6 5.3c-0.1 0.75-0.7 1.25-1.45 1.25h-5c-0.75 0-1.35-0.5-1.45-1.25l-0.6-5.3c-0.05-0.5 0.35-0.95 0.85-0.95z",
  fill: "#4a7fa5"
}), /*#__PURE__*/React.createElement("rect", {
  x: 4.7,
  y: 31.4,
  width: 6.4,
  height: 1.7,
  rx: 0.85,
  fill: "#333a40"
}));

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 17.8,
  y: 26.8,
  width: 4.5,
  height: 1.9,
  fill: "#333a40"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m15 21.5h4.6v12.5h-4.6c-2.3-3.9-2.3-8.6 0-12.5z",
  fill: "#f2c14e"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 14.2,
  y: 32.4,
  width: 5.4,
  height: 1.8,
  rx: 0.6,
  fill: "#333a40"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 20.5,
  y: 28.2,
  width: 19.5,
  height: 2.6,
  rx: 0.8,
  fill: "#333a40"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 29,
  y: 19.5,
  width: 11,
  height: 9,
  rx: 1,
  fill: "#e58a2f"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 21.5,
  y: 15.5,
  width: 8.5,
  height: 13,
  rx: 1.3,
  fill: "#e58a2f"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 22.8,
  y: 17,
  width: 5.2,
  height: 4.8,
  rx: 0.9,
  fill: "#cfe6f2"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 24.2,
  y: 13.7,
  width: 3,
  height: 1.9,
  rx: 0.9,
  fill: "#f2c14e"
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 31.8,
  r: 3,
  fill: "#333a40"
});

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 31.8,
  r: 1.2,
  fill: "#9aa7b0"
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 31.8,
  r: 3,
  fill: "#333a40"
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 31.8,
  r: 1.2,
  fill: "#9aa7b0"
});

function SvgSnowRemoval(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnowRemoval);
export default __webpack_public_path__ + "static/media/snow-removal.1d31687cf6870180464d9e29f4d8858b.svg";
export { ForwardRef as ReactComponent };